
interface ArrowProps {
    className: string;
}

export function RightArrowIcon({ className }: ArrowProps) {
    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width="800"
            height="800"
            viewBox="0 0 123.959 123.959">

            <path d="m38.217 1.779 56 56c2.3 2.3 2.3 6.1 0 8.401l-56 56c-3.801 3.8-10.2 1.1-10.2-4.2v-112c0-5.301 6.399-8.001 10.2-4.201z" />
        </svg>
    );
}
